import React, { Component } from 'react';
import ProjectPage from '../../components/ProjectPage';
import Table from '../../components/Table';
import Banner from '../../images/projects/TankBanner.jpg'

class Tank extends Component {
  render() {
    return (
    <ProjectPage title="Tank" banner={Banner}>

      <div className='project-page-part'>

        <Table className="centered" data={{
          Status : "Finished",
          Type : "School project",
          Engine : "Unity",
          Language : "C#",
          Duration : "1 week",
          Team : "Group of 3",
          Date : "2022"
        }}/>

      </div>

      <div className='project-page-part'>

        <h3>Context :</h3>

        <p className='basic-text'>
          The objective of this project was to learn about the different pathfinding algorithms (NavMesh, A*, Dijkstra), state machines and behaviour trees by adding an AI to an Unity template. 
        </p>

      </div>

      <div className='project-page-part'>

        <h3>Game :</h3>

        <p className='basic-text'>
          Tank is a top-down tank game, where you have to capture zones and make more points than your opponent within the time limit.<br/>
          You can play versus an other player, an AI or watch 2 AI fight. 
        </p>

      </div>

      <div className='project-page-part'>

        <h3>My contribution :</h3>

        <ul className="basic-text">
          <li>A* and Dijkstra implementation</li>
          <li>Behaviour Tree</li>
          <li>Global systems</li>
          <li>UI</li>
        </ul>

      </div>

      <div className='project-page-part'>

        <h3>Gameplay :</h3>

        <iframe className='project-video' title='Tank demo' allowFullScreen
        src="https://youtube.com/embed/NxkcBAN0lBs">
        </iframe>

      </div>
            
    </ProjectPage>
    );
  }
}

export default Tank;